import React, { Component } from 'react';
import { Pagination } from 'react-bootstrap';

/****** 
 * Props List For Use Pagination Component
 * 
 * 1. parPage (obj)
 * 2. query (obj)
 * 3. updateAction (function)
 * 4. meta (obj)
 * 5. url
 * 
********/

class Itempagination extends Component {

  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick = (i) => {
    if( i >= 1 && i <= this.props.meta.pages && i !== this.props.meta.page){
      let pConf = {...this.props};
      pConf.meta.page = i;
      this.props.mainFunc(pConf,false);
    }
  }

  render() {
      let items = [];
      if(this.props.meta.pages > 8){
        if( this.props.meta.page > 2 ){items.push(<Pagination.Ellipsis key="dot1" />)}

        if( this.props.meta.page > 1){
          items.push(<Pagination.Item key={1} onClick={ () => this.handleClick(this.props.meta.pages-1) }>{this.props.meta.page-1}</Pagination.Item>)
        }

        items.push(<Pagination.Item key={2} onClick={ () => this.handleClick(this.props.meta.pages1) } active>{this.props.meta.page}</Pagination.Item>)

        if( this.props.meta.page < this.props.meta.pages ){
          items.push(<Pagination.Item key={3} onClick={ () => this.handleClick(this.props.meta.pages+1) }>{this.props.meta.page+1}</Pagination.Item>)
        }

        if( this.props.meta.page < this.props.meta.pages - 1){items.push(<Pagination.Ellipsis key="dot2" />)}
      }else{
        for (let i = 1; i < this.props.meta.pages + 1; i++) {
          items.push(<Pagination.Item key={i} onClick={ () => this.handleClick(i) } active={ i === this.props.meta.page}>{i}</Pagination.Item>)
        }
      }
      
      return (
        <div className="pagination-div">
          <Pagination>
            <Pagination.First title="اول" onClick={ () => this.handleClick(1) } disabled={ this.props.meta.page === 1} />
            <Pagination.Prev title="قبلی" onClick={ () => this.handleClick(this.props.meta.page - 1) } disabled={ this.props.meta.page === 1} />
              {items}
            <Pagination.Next title="بعدی" onClick={ () => this.handleClick(this.props.meta.page + 1) } disabled={ this.props.meta.page === this.props.meta.pages}/>
            <Pagination.Last title="آخر" onClick={ () => this.handleClick(this.props.meta.pages) }  disabled={ this.props.meta.page === this.props.meta.pages }/>
          </Pagination>
        </div>
      );   
  }
}

Itempagination.defaultProps = {
  meta: {
    pages:1,
    page:1
  },
  url : "",
  query : {},
  updateAction : () => {},
  perPage : 10
};

export default Itempagination;